import { ubtSendError } from '@/shared/utils/ubt';
import { VerifyQueryParamsTypeEnum } from '@/shared/verify-credit-controller/types';
import type PersonalProfile from './index';

/** 提交主按钮点击-场景定制ubt埋点 */
export function submitBtnClickCustomUbt(instance: PersonalProfile): void {
  try {
    const { type: queryType } = instance.queryParams || {};

    switch (queryType) {
      case VerifyQueryParamsTypeEnum.FromSms:
        instance.$ubtPageButton(
          'finance_smsMarketing_landingPage_download_baseInfo',
          'platform',
          instance.platformValue,
        );
        break;
      default:
        break;
    }
  } catch (err) {
    ubtSendError(err as Error);
  }
}
